import { observer } from 'mobx-react-lite';
import AddFileProviderView from './AddFileProviderView';
import FileProviderAndScopesView from './FileProviderAndScopesView';
import changeSelectedFileProvider from '../actions/changeSelectedFileProvider';
import FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import { FileProvidersFilter } from '../store/schema/FileProvidersFilter';
import getAddedProviders from '../utils/getAddedProviders';
import { FocusZone, FocusZoneDirection } from '@fluentui/react/lib/FocusZone';
import { getProviderLoadState } from 'owa-fileprovider-store/lib/selectors/getProviderLoadState';
import AttachmentDataProviderScope from 'owa-service/lib/contract/AttachmentDataProviderScope';
import * as React from 'react';
import {
    FileProviderViewState,
    FileSelectionFilter,
    ProviderLoadStateOption,
} from 'owa-fileprovider-store';

const classNames = require('classnames');
const styles = require('./FileProvidersPane.scss');

export interface FileProvidersPaneProps extends React.HTMLProps<HTMLDivElement> {
    fileSelectionFilter: FileSelectionFilter;
    onLocalComputerFilesSelected: (files: File[], fileSelectionFilter: FileSelectionFilter) => void;
    filePickerPanelViewState: FilePickerPanelViewState;

    // Optional
    fileProvidersFilter?: FileProvidersFilter;
    selectedFileProvider?: FileProviderViewState;
    showFileProviderInlineView?: boolean;
}

export default observer(function FileProvidersPane(props: FileProvidersPaneProps) {
    const createFileProvidersView = (providers: FileProviderViewState[]): JSX.Element[] => {
        return providers.map(providerViewState => {
            return createFileProviderAndScopesView(
                providerViewState,
                providerViewState === props.selectedFileProvider &&
                    !props.showFileProviderInlineView,
                props.filePickerPanelViewState
            );
        });
    };
    const providersLoaded = getProviderLoadState() === ProviderLoadStateOption.Loaded;
    return (
        <div className={styles.container}>
            <FocusZone
                className={classNames(styles.fileProviders, 'customScrollBar')}
                isCircularNavigation={false}
                direction={FocusZoneDirection.vertical}>
                {providersLoaded &&
                    createFileProvidersView(
                        getAddedProviders(props.fileSelectionFilter, props.fileProvidersFilter)
                    )}
                {providersLoaded &&
                    props.fileProvidersFilter !== FileProvidersFilter.InsertLinkBusiness && (
                        <AddFileProviderView />
                    )}
            </FocusZone>
        </div>
    );
});

function createFileProviderAndScopesView(
    viewState: FileProviderViewState,
    isSelected: boolean,
    filePickerViewState: FilePickerPanelViewState
) {
    const onClickGenerator = (scope: AttachmentDataProviderScope) => () => {
        changeSelectedFileProvider(viewState, filePickerViewState, scope);
    };
    return (
        <FileProviderAndScopesView
            key={viewState.viewType}
            name={viewState.name}
            providerType={viewState.viewType}
            isSelected={isSelected}
            selectedScope={filePickerViewState.selectedProviderScope}
            onClickGenerator={onClickGenerator}
            scopes={viewState.scopes}
        />
    );
}
